import {MaterialType} from "./general-profile";

export type CreateProfileParams = {
    productCode?: string
    materialType?: MaterialType,
    color?: string
}

export class GeneralProfileFactory{

    public static createProfile(){
        throw new Error('Not implemented')
    }

}